import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  getStudent,
  studentStatus,
} from "../../../features/slices/studentManagementReducer";
import addChapterIcon from "../../../assets/images/addChapterIcon.png";
import { getStudentCourse } from "../../../features/slices/studentManagement/studentCourse";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment/moment";
import CommonPagination from "../../../components/CommonPagination";
import ExportToExcel from "../../../components/ExportToExcel";
import { toastService } from "../../../utils/toastify";
import CommentListModal from "../../../components/FeedManagement/CommentListModal";
import TableSkeleton from "../../../components/TableSkeleton";
import { getEmail } from "../../../utils/getToken";
import { Link, useLocation } from "react-router-dom";
import { courseStatusChanged } from "../../../features/slices/coursesManagement";
const initialState = {
  currentPage: 1,
  searchQuery: "",
  fromDate: "",
  toDate: "",
  timeframe: "",
  status: "",
};
const CourseDetails = () => {
  const [iState, setUpdateState] = useState(initialState);
  const [page, setPage] = useState(1);
  const {
    deleteModal,
    deleteReasonModal,
    id,
    searchQuery,
    status,
    data,
    fromDate,
    toDate,
    timeframe,
  } = iState;
  const tableRef = useRef(null);
  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };
  const dispatch = useDispatch();
  const { state } = useLocation();
  const { course, loading } = useSelector((state) => {
    return state.studentCourse;
  });
  console.log({ course });

  useEffect(() => {
    dispatch(getStudentCourse({ page, userId: state?._id }));
    window.scrollTo(0, 0);
  }, [page]);

  const handleChangeStatus = (e, id) => {
    const status = e.target.checked ? "ACTIVE" : "INACTIVE";
    dispatch(
      courseStatusChanged({
        id: id,
        status: status,
      })
    ).then((data) => {
      if (data?.payload?.code === 200) {
        dispatch(getStudentCourse({ userId: state?._id })).then((data) => {
          if (data?.payload?.code === 200) {
            toastService.success("Status updated successfully");
          } else {
            toastService.error(data?.payload?.message);
          }
        });
      }
    });
  };
  // const handleDelete = () => {
  //   dispatch(courseStatusChanged({ id, status: "DELETED" })).then((res) => {
  //     if (res?.payload?.code == 200) {
  //       toastService.success("Course deleted successfully");
  //       dispatch(getStudentCourse());
  //       setUpdateState({ ...initalState });
  //     }
  //   });
  // };

  const handleSearch = (e) => {
    const { name, value } = e.target;
    setUpdateState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleTimeFrame = (e) => {
    const queryParams = { timeframe: e.target.value, userId: state?._id };
    setUpdateState((prev) => ({
      ...prev,
      timeframe: e.target.value,
    }));
    dispatch(getStudentCourse(queryParams)).then((data) => {
      if (data?.payload?.code === 200) {
        // setUpdateState((prev) => ({
        //   ...prev,
        //   timeframe: "",
        // }));
      }
    });
  };
  const handleFilter = (e) => {
    const status = e.target.value;
    setUpdateState((prev) => ({
      ...prev,
      status: status,
    }));
    dispatch(
      getStudentCourse({
        status: status,
        search: searchQuery?.trim(),
        userId: state?._id,
      })
    );
  };
  const handleReset = () => {
    setUpdateState(initialState);
    dispatch(getStudentCourse({ page, userId: state?._id }));
  };
  useEffect(() => {
    if (searchQuery.trim() !== "") {
      const delayDebounceFunc = setTimeout(() => {
        dispatch(
          getStudentCourse({
            search: searchQuery?.trim(),
            status: status,
            userId: state?._id,
          })
        ).then((res) => {
          if (res?.payload?.code == 200) {
          }
        });
      }, 1000);
      return () => clearTimeout(delayDebounceFunc);
    }
  }, [searchQuery, dispatch]);
  const handleSubmit = () => {
    const queryParams = {
      page: 1,
      search: searchQuery?.trim(),
      status: status,
      userId: state?._id,
    };
    if (fromDate && toDate) {
      queryParams.startDate = fromDate;
      queryParams.endDate = toDate;
    } else if (timeframe) {
      queryParams.timeframe = timeframe;
    }
    dispatch(getStudentCourse(queryParams)).then((data) => {
      if (data?.payload?.code === 200) {
        // setUpdateState((prev) => ({
        //   ...prev,
        //   searchQuery: "",
        //   fromDate: "",
        //   toDate: "",
        //   timeframe: "",
        // }));
      }
    });
  };
  return (
    <div className="tab-pane fade active show">
      <div className="FilterArea">
        <div className="FilterLeft">
          <div className="form-group">
            <label>From Date</label>
            <input
              type="date"
              className="form-control"
              value={fromDate}
              disabled={timeframe}
              name="fromDate"
              onChange={(e) => handleSearch(e)}
            />
          </div>
          <div className="form-group">
            <label>To Date</label>
            <input
              type="date"
              className="form-control"
              name="toDate"
              value={toDate}
              disabled={timeframe}
              onChange={(e) => handleSearch(e)}
            />
          </div>
          <div className="form-group">
            <label>&nbsp;</label>
            <button className="Button" onClick={handleSubmit}>
              Apply
            </button>
          </div>
          <div className="form-group">
            <label>Timeframe</label>
            <select
              className="form-control"
              name="timeframe"
              value={timeframe}
              disabled={fromDate || toDate}
              onChange={(e) => handleTimeFrame(e)}
            >
              <option value="" hidden>
                Select
              </option>
              <option value="Today">Today</option>
              <option value="Week">This Week</option>
              <option value="Month">This Month</option>
            </select>
          </div>
        </div>
      </div>
      <div className="NewFilter">
        <div
          className="SearchBox"
          style={{
            width: "60%",
          }}
        >
          <input
            type="search"
            className="SearchInput"
            placeholder="Search here by ID, Name, or Others"
            name="searchQuery"
            value={searchQuery}
            onChange={(e) => handleSearch(e)}
          />
          <span>
            <i className="fa fa-search" />
          </span>
        </div>

        <div className="Actions">
          <button className="Button Cancel  ml-2" onClick={handleReset}>
            <i className="fa fa-refresh" />
          </button>
          <ExportToExcel
            data={course?.result?.[0]?.paginationData}
            fileName="StudentCourse"
          />
        </div>
      </div>
      <div className="TableList">
        <table className="table-hover" style={{ width: "120%" }}>
          <thead>
            <tr>
              <th>Sr. No</th>
              <th>Course Id</th>
              <th>Name of Course</th>
              <th>Teacher Name</th>
              <th>Course Type</th>
              <th>Category &amp; Topic</th>
              <th>Language</th>
              <th>Enrollment Date</th>
              <th>Progress Status</th>
              <th>Q&amp;A</th>
              <th>Ratings</th>
            </tr>
          </thead>
          <tbody>
            {!loading ? (
              course?.result?.[0]?.paginationData?.length > 0 ? (
                course?.result?.[0]?.paginationData?.map((res, i) => {
                  return (
                    <tr key={res?._id}>
                      <td>{i + 1 + (page - 1) * 10}</td>
                      <td>
                        <div>{res?.courseData?.course_number}</div>
                      </td>
                      <td>
                        <div className="fw500">{res?.courseData?.title}</div>
                      </td>
                      <td>
                        <div className="fw500">
                          {res?.courseData?.teacherName}
                        </div>
                      </td>
                      <td>
                        <div>{res?.courseData?.courseType}</div>
                      </td>
                      <td>
                        {res?.categoryData?.categoryName} &{" "}
                        {res?.topicData?.topicName}
                      </td>
                      <td>
                        <div>English</div>
                      </td>
                      <td>
                        <div>{moment(res?.createdAt).format("DD/MM/YYYY")}</div>
                      </td>
                      <td>
                        <div>{Math.round(res?.percentage)}%</div>
                      </td>
                      <td className="d-flex align-items-center">
                        <Link
                          to="/courses/courseDetails?type=student"
                          className="LinkDirect"
                          state={{ id: res?.courseId, type: "QA" }}
                        >
                          {res?.qaCounts}
                        </Link>
                      </td>
                      <td>
                        <Link
                          to={"/courses/courseRating?type=student"}
                          className="LinkDirect"
                          state={res?.courseId}
                        >
                          {Math.round(res?.averageRating)}
                          {`(${res?.ratingCount})`}
                        </Link>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={10}>No Challanges Data</td>
                </tr>
              )
            ) : (
              <TableSkeleton />
            )}
          </tbody>
        </table>
      </div>
      <div className="Pagination">
        {course?.result?.[0]?.totalCount?.[0]?.count > 0 && (
          <>
            <p>
              Showing {(page - 1) * 10 + 1} to{" "}
              {course?.result?.[0]?.paginationData?.length + (page - 1) * 10} of{" "}
              {course?.result?.[0]?.totalCount?.[0]?.count} results
            </p>
            <div className="PaginationRight">
              {course?.result?.[0]?.totalCount?.[0]?.count > 0 && (
                <CommonPagination
                  activePage={page}
                  itemsCountPerPage={10}
                  totalItemsCount={
                    course?.result?.[0]?.totalCount?.[0]?.count || 0
                  }
                  pageRangeDisplayed={4}
                  onChange={handlePageChange}
                  itemClass="page-item"
                  linkClass="page-link"
                />
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default CourseDetails;
